import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { MdCalendarToday, MdFlag, MdAccessTime, MdCheckCircleOutline, MdPendingActions, MdOutlineTask } from "react-icons/md";
// import { RiProgress3Line } from "react-icons/ri";
import "./UserTasks.css";

const API = "https://daily-report.spectratally.net/api";

const priorityCls = p => p==="High"?"badge-high":p==="Low"?"badge-low":"badge-med";

export default function UserTasks({ user }) {
  const [tasks, setTasks] = useState([]);
  const [toast, setToast] = useState(null);
  const [filter, setFilter] = useState("all");

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(null),2500); };

  const loadTasks = useCallback(async () => {
    try { const r = await axios.get(`${API}/tasks?userId=${user.id}`); setTasks(r.data.data); }
    catch { /* silent */ }
  }, [user.id]);

  useEffect(() => { loadTasks(); }, [loadTasks]);

  const updateStatus = async (id, status) => {
    await axios.put(`${API}/tasks/${id}`, { status });
    loadTasks(); showToast("Status updated");
  };

  const filtered = filter==="all" ? tasks : tasks.filter(t=>t.status===filter);
  const pending = tasks.filter(t=>t.status==="Pending").length;
  const inProg  = tasks.filter(t=>t.status==="In Progress").length;
  const done    = tasks.filter(t=>t.status==="Done").length;

  return (
    <div className="ut-wrap">
      <div className="ut-header">
        <div className="ut-header-left">
          <div className="ut-avatar">{user.name.charAt(0)}</div>
          <div>
            <h2>Welcome back, {user.name.split(" ")[0]}</h2>
            <p>{user.department ? `Department: ${user.department}` : "Employee Portal"}</p>
          </div>
        </div>
        <div className="ut-stats">
          <div className="ut-stat"><MdPendingActions /><span>{pending}</span><small>Pending</small></div>
          <div className="ut-stat in-prog">ok<span>{inProg}</span><small>In Progress</small></div>
          <div className="ut-stat done"><MdCheckCircleOutline /><span>{done}</span><small>Done</small></div>
        </div>
      </div>

      <div className="ut-filter-row">
        {[["all","All Tasks",tasks.length],["Pending","Pending",pending],["In Progress","In Progress",inProg],["Done","Done",done]].map(([v,l,c])=>(
          <button key={v} className={`ut-filter-btn ${filter===v?"active":""}`} onClick={()=>setFilter(v)}>
            {l} <span className="utf-count">{c}</span>
          </button>
        ))}
      </div>

      {filtered.length===0 ? (
        <div className="ut-empty">
          <MdOutlineTask />
          <p>{filter==="all" ? "No tasks assigned yet" : `No ${filter} tasks`}</p>
          <small>Your admin will assign tasks to you</small>
        </div>
      ) : (
        <div className="task-card-grid">
          {filtered.map(t => (
            <div className={`task-card tc-${t.status.replace(" ","-").toLowerCase()}`} key={t.id}>
              <div className="tc-top">
                <div className="tc-title">{t.title}</div>
                <span className={`badge ${priorityCls(t.priority)}`}>{t.priority}</span>
              </div>
              {t.description && <p className="tc-desc">{t.description}</p>}
              <div className="tc-meta">
                {t.dueDate && <span className="tc-chip"><MdCalendarToday />{t.dueDate}</span>}
                <span className="tc-chip"><MdFlag />{t.priority}</span>
                <span className="tc-chip"><MdAccessTime />{new Date(t.createdAt).toLocaleDateString("en-IN")}</span>
              </div>
              <div className="tc-footer">
                <select className={`tc-status-sel s-${t.status.replace(" ","-").toLowerCase()}`}
                  value={t.status} onChange={e=>updateStatus(t.id,e.target.value)}>
                  <option>Pending</option>
                  <option>In Progress</option>
                  <option>Done</option>
                </select>
              </div>
            </div>
          ))}
        </div>
      )}
      {toast && <div className="toast-small"><MdCheckCircleOutline /> {toast}</div>}
    </div>
  );
}
